import React from 'react';
import { has } from 'lodash';
export default function DefaultEntryComponent(props) {
  const {
    mention,
    theme,
    // eslint-disable-next-line
    isFocused, // eslint-disable-line
    searchValue, // eslint-disable-line
    ...parentProps
  } = props;

  const displayName = has(mention, 'display_name') ? mention.display_name : mention.name;

  return (
    <div {...parentProps}>
      <span className={theme?.mentionSuggestionsEntryText}>{displayName}</span>
    </div>
  );
}
